import { memo, useState, useCallback, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { Popover } from 'antd'
import UserInfo from '@/components/UserInfo/UserInfo'
import LunwenManage from '@/components/LunwenManage/LunwenManage'
import HumanService from '@/components/HumanService/HumanService'
// import BaseModal from '@/components/BaseModal/BaseModal'
import { Modal } from 'antd'
import { useUserStore } from '@/hooks/useUserStore'
import { useLoginModal } from '@/store/loginContext'
import { usePayCenter } from '@/store/payCenterContext'
import { usePlatformModal } from '@/store/platformModalContext'
import { sessionStore, localStore } from '@/utils/storage'
import './LoginBtn.less'
interface MenuItem {
  label: string
  icon: string
  key: string
  action?: () => void
}
// 菜单配置常量
const MENU_ITEMS: MenuItem[] = [
  { label: '个人中心', icon: 'icon-yonghu', key: 'profile' },
  { label: '充值中心', icon: 'icon-chongzhi', key: 'recharge' },
  { label: '论文管理', icon: 'icon-folder', key: 'papers' },
  { label: '使用说明', icon: 'icon-xinxi', key: 'help' },
  { label: '人工客服', icon: 'icon-kefuyunying', key: 'service' },
  { label: '退出登录', icon: 'icon-caozuo-kaiguan', key: 'logout' }
]
const LoginBtn = ({ history, onHideMb, onGetType }: any) => {
  const { userInfo, dispatch } = useUserStore()
  const { showLoginModal } = useLoginModal()
  const { showPayCenter } = usePayCenter()
  const { showPlatformModal } = usePlatformModal()
  const [open, setOpen] = useState(false)
  const [showUserInfoVisible, setShowUserInfoVisible] = useState(false)
  const [showLunwenManageVisible, setShowLunwenManageVisible] = useState(false)
  const [showServeVisible, setShowServeVisible] = useState(false)

  // 使用Hook中的用户信息，如果没有则使用props传入的
  // 处理菜单点击
  const handleMenuClick = (index: number, item: any) => {
    setOpen(false)
    if (item.key == 'profile') {
      setShowUserInfoVisible(true)
    }
    if (item.key == 'papers') {
      setShowLunwenManageVisible(true)
    }
    if (item.key == 'help') {
      showPlatformModal()
    }
    if (item.key == 'service') {
      setShowServeVisible(true)
    }
    if (item.key == 'recharge') {
      if (item.type) {
        showPayCenter({ type: item.type })
        return
      }
      showPayCenter()
    }
    if (item.key == 'logout') {
      logout()
    }
    onHideMb?.()
  }
  const logout = () => {
    localStore.clear()
    sessionStore.clear()
    dispatch({ type: 'CLEAR_USER_INFO' })
    setShowUserInfoVisible(false)
    history.push('/')
  }
  // 处理登录按钮点击
  const handleLoginClick = useCallback(() => {
    showLoginModal()
  }, [showLoginModal])

  // 渲染菜单内容
  const menuContent = useMemo(
    () => (
      <ul className='login-btn-popover'>
        {MENU_ITEMS.map((item, index) => (
          <li key={item.key} onClick={() => handleMenuClick(index, item)} className='menu-item'>
            <i className={item.icon} style={item.label == '论文管理' ? { transform: 'translateX(-1px)' } : {}} />
            <span style={item.label == '论文管理' ? { transform: 'translateX(-3px)' } : {}}>{item.label}</span>
          </li>
        ))}
      </ul>
    ),
    [handleMenuClick]
  )

  // 渲染登录按钮
  const renderLoginButton = () => (
    <div className='LoginBtn-container' onClick={handleLoginClick}>
      <div className='btn'>立即登录</div>
    </div>
  )

  // 渲染用户信息按钮
  const renderUserButton = () => (
    <Popover
      content={menuContent}
      title={null}
      placement='bottom'
      trigger='hover'
      arrow={false}
      overlayClassName='LoginBtn-popover'
      open={open}
      onOpenChange={(o: boolean) => setOpen(o)}
    >
      <div className='LoginBtn-container LoginBtn-container-2'>
        <div className='btn'>
          <img
            src={userInfo?.headimgurl}
            alt='用户头像'
            onError={e => {
              e.currentTarget.src = userInfo?.headimgurl
            }}
          />
          <label>{userInfo?.nickname}</label>
          <i className='icon-below-s' />
        </div>
      </div>
    </Popover>
  )

  return (
    <>
      {!userInfo ? renderLoginButton() : renderUserButton()}
      {showUserInfoVisible && (
        <UserInfo
          visible={showUserInfoVisible}
          onCancel={() => setShowUserInfoVisible(false)}
          logout={logout}
          handleMenuClick={handleMenuClick}
        />
      )}
      {showLunwenManageVisible && (
        <LunwenManage
          visible={showLunwenManageVisible}
          onCancel={() => setShowLunwenManageVisible(false)}
          onGetType={onGetType}
        />
      )}
      {showServeVisible && (
        <Modal
          wrapClassName={`base-modal-2`}
          open={showServeVisible}
          onCancel={() => setShowServeVisible(false)}
          title=''
          footer={null}
          centered
          width={300}
        >
          <HumanService />
        </Modal>
      )}
    </>
  )
}

export default memo(withRouter(LoginBtn))
